export default function Footer() {

    return (
        <>
            <iframe src="/static/components/b.html" frameBorder="0" width="100%" height="366px" style={{ minWidth: '1300px' }}></iframe>
        </>
    )
}